import React from 'react';
import cx from 'classnames';
import {
  faUsers,
  faSitemap,
  faUserFriends,
  faFolder,
} from '@fortawesome/pro-solid-svg-icons';
import { Icon } from 'js/components';

function OrgTreeNodeTypeIcon({ node, className }) {
  if (node?.type === 'team') {
    return (
      <Icon
        className={cx('row-icon team-icon', className)}
        fixedWidth
        icon={faUsers}
      />
    );
  }

  if (node?.isRoot) {
    return (
      <Icon
        className={cx('row-icon org-icon', className)}
        fixedWidth
        icon={faSitemap}
      />
    );
  }

  return (
    <Icon
      className={cx('row-icon folder-icon', className)}
      fixedWidth
      size="xl"
      icon={faUserFriends}
      mask={faFolder}
      transform="shrink-9 down-1"
    />
  );
}

export default OrgTreeNodeTypeIcon;
